// extracted by mini-css-extract-plugin
export var avatar = "_qv-3";
export var avatarContainer = "_qv-2";
export var avatarSpacer = "_qv-5";
export var avatarSpacerContainer = "_qv-4";
export var avatarStackContainer = "_qv-1";
export var bubble = "_qv-0";
export var remainderBubble = "_qv-6";